/**
 * @generated SignedSource<<e96175896f14db430807e28a892df9a9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FeedbackCastPanelFeedbackFragment$data = {
  readonly proposalFeedback: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly sender: {
          readonly address: {
            readonly address: string;
          };
        };
        readonly " $fragmentSpreads": FragmentRefs<"FeedbackRowFragment">;
      };
    }>;
  };
  readonly " $fragmentType": "FeedbackCastPanelFeedbackFragment";
};
export type FeedbackCastPanelFeedbackFragment$key = {
  readonly " $data"?: FeedbackCastPanelFeedbackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FeedbackCastPanelFeedbackFragment">;
};

import FeedbackCastPanelPaginationQuery_graphql from './FeedbackCastPanelPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "proposalFeedback"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "proposalId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": FeedbackCastPanelPaginationQuery_graphql
    }
  },
  "name": "FeedbackCastPanelFeedbackFragment",
  "selections": [
    {
      "alias": "proposalFeedback",
      "args": [
        {
          "kind": "Variable",
          "name": "proposalId",
          "variableName": "proposalId"
        }
      ],
      "concreteType": "ProposalFeedbackConnection",
      "kind": "LinkedField",
      "name": "__FeedbackCastPanelFragment_proposalFeedback_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ProposalFeedbackEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProposalFeedback",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Delegate",
                  "kind": "LinkedField",
                  "name": "sender",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Address",
                      "kind": "LinkedField",
                      "name": "address",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "address",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FeedbackRowFragment"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "1a330953d55292759388daa6db9222a8";

export default node;
